import axios from './axios';

export default {
  list() {
    return axios.get('/payments');
  },
  create(amount) {
    return axios.post('/payments', { payment: { amount } });
  },
};
